import { getOtherLoginUrl, logger } from '@/utils';
import { autobind, Injectable } from '@kaokei/use-vue-service';
import { DaoService } from '../dao.service';
import { DeviceManager } from '@/utils';
import { DeviceErrorDescription } from '@/utils/device/error';
import { IError } from '@/utils/device/interface';
import { checkBrowser } from '@/utils/check';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { CosService } from '../cosmaz.service';
import { UserService } from '../user.service';
import TRTC, { TRTCDeviceAction, TRTCDeviceType } from 'trtc-sdk-v5';
import { markRaw } from 'vue';
// import { cloneDeep } from 'lodash-es';

const delayFn = (time = 2) => {
  // 每次检测至少10s以上，否则显得不够真实
  return new Promise(resolve => {
    window.setTimeout(() => resolve(true), time * 1000);
  });
};
TRTC.setLogLevel(5);
export type StatusType = 'wait' | 'process' | 'finish' | 'error';

export type DeviceItemType = {
  status: StatusType;
  txt: string;
  deviceList: MediaDeviceInfo[];
};

export type DeviceStateType = {
  showVideo: boolean;
  hasClickChecked: boolean;
  browser: DeviceItemType;
  camera: DeviceItemType;
  micro: DeviceItemType;
  screen: DeviceItemType;
};

export type StepItemtype = {
  label: string;
  status: StatusType;
  resultStatus: StatusType;
  comName: string;
  // 0 标识检测设备 1 三方监控 2 标识验证身份 3 标识等待考试
  stepType: 0 | 1 | 2 | 3;
  // 记录是否是错误状态
  recordError: boolean;
};

// const StatusMap = ['检测未通过', '检测通过', '跳过检测', '未检测'];

enum CheckStatusEnum {
  FAIL = 0, // 检测未通过
  PASS = 1, // 检测通过
  SKIP = 2, // 跳过检测
  NO_CHECK = 3, // 未检测
}
@Injectable()
export class EnvCheckerService {
  route: any = useRoute();
  router: any = useRouter();
  public trtc?: TRTC;
  public pageInitLoading = false;
  public userExamId = 0;
  public contestInfoId = 0;
  public stream?: MediaStream; // 视频流和音频流
  public error?: Event; // 错误信息
  // 设备检测状态 active | inactive
  public deviceActiveStatus = '';

  // 检测步骤
  public checkStep: StepItemtype[] = [
    {
      label: '设备检测',
      status: 'process',
      resultStatus: 'wait',
      recordError: false,
      comName: 'step-one',
      stepType: 0,
    },
    {
      label: '三方监控',
      status: 'wait',
      resultStatus: 'wait',
      recordError: false,
      comName: 'step-two',
      stepType: 1,
    },
    {
      label: '身份验证',
      status: 'wait',
      resultStatus: 'wait',
      recordError: false,
      comName: 'step-three',
      stepType: 2,
    },
    {
      label: '开始作答',
      status: 'wait',
      resultStatus: 'wait',
      recordError: false,
      comName: 'step-four',
      stepType: 3,
    },
  ];

  public combinationResult: any = null;
  // 初始化获取检测结果
  public InitCheckResult = {
    device: CheckStatusEnum.NO_CHECK,
    face: CheckStatusEnum.NO_CHECK,
    mobile: CheckStatusEnum.NO_CHECK,
  };

  // 检测浏览器的结果
  public checkBrowserResult: any;
  // 检测ID
  public checkId = 0;

  public currentStepIndex = 0;

  // 身份校验图片url
  public photoDataUrl = '';
  // 考试开始时间
  public startExamTimestamp = 0;
  // getRemainTime时返回的服务器时间
  public serverRemainTime = 0;
  // 每隔1秒的倒计时定时器
  public countdownTimer = 0;
  // 本地时间
  public localTime = 0;
  // 获取serverRemainTime的本地时间
  public localGetRemainTime = 0;
  // 本地时间间隔
  public localTimeGap = 0;
  // 倒计时信息
  public countDownTimeData = {
    h: '--',
    min: '--',
    sec: '--',
  };
  // 是否已经开始考试
  public isCanEntrance = false;

  public deviceManager?: any;

  public DeviceState: DeviceStateType = {
    showVideo: false,
    hasClickChecked: false,
    browser: {
      status: 'wait',
      txt: '设备待检测',
      deviceList: [],
    },
    camera: {
      status: 'wait',
      txt: '设备待检测',
      deviceList: [],
    },
    micro: {
      status: 'wait',
      txt: '设备待检测',
      deviceList: [],
    },
    screen: {
      status: 'wait',
      txt: '待分享屏幕',
      deviceList: [],
    },
  };

  public NoDeviceVisible = false;
  public NeedAutoCheckDevice = false;

  // 配置的身份检测示例地址
  public faceCheckStandardUrl = '';

  public examDetail: any = {};
  // 是否已经请求获取考试明细信息标识
  public examDetailGeted = false;
  // 是否展示屏幕录制引导标识
  public showScreenGuide = false;
  // 展示设备断连提示
  public showDeviceDisconnect = false;

  constructor(
    public daoService: DaoService,
    public cosService: CosService,
    public userService: UserService
  ) {
    this.deviceManager = new DeviceManager();
    const trtc = TRTC.create();
    this.trtc = markRaw(trtc);
  }

  @autobind
  public async initPage() {
    const { qs, mockFlag } = this.route.query;
    try {
      const { id, contestId } = JSON.parse(window.atob(qs));
      this.userExamId = id;
      this.contestInfoId = contestId;
    } catch (e) {
      message.error('参数解析异常，请确保从正确的入口处进入');
    }
    if (mockFlag === 'true') {
      try {
        await this.daoService.preStartMockExam(this.userExamId);
      } catch (e: SafeAny) {
        if (e && e.errCode === 5014) {
          const otherLoginUrl = getOtherLoginUrl() || '';
          if (otherLoginUrl) {
            setTimeout(() => {
              window.location.replace(otherLoginUrl);
            }, 2000);
          }
        }
      }
    }
    this.getCombinationResult();
  }

  @autobind
  public goStep(index: number, judgeStep = false) {
    const prevStepIndex = this.currentStepIndex;
    if (judgeStep) {
      // 需要校验一下能否进行下一步
      if ([0, 3].includes(this.InitCheckResult.device)) {
        if (prevStepIndex < index) return;
      }
      // 得过滤掉不需要身份验证的情况
      if (
        [0, 3].includes(this.InitCheckResult.face) &&
        this.combinationResult.faceCheckConfigStatus
      ) {
        if (prevStepIndex < index) return;
      }
      // 如果第2步存在异常
      if (
        this.InitCheckResult.device === CheckStatusEnum.PASS &&
        this.InitCheckResult.face === CheckStatusEnum.SKIP &&
        this.combinationResult.faceCheckConfigStatus
      ) {
        if (prevStepIndex < index) return;
      }
    }
    this.currentStepIndex = index;
    for (let i = 0; i < this.checkStep.length; i++) {
      const itemStep = this.checkStep[i];
      if (i < index) {
        const { resultStatus, status } = itemStep;
        this.checkStep[i] = {
          ...itemStep,
          status: ['error'].includes(status)
            ? 'error'
            : ['error'].includes(resultStatus)
            ? 'error'
            : 'finish',
        };
      } else if (i === index) {
        this.checkStep[i] = {
          ...itemStep,
          status: 'process',
        };
      } else {
        this.checkStep[i] = {
          ...itemStep,
          status: 'wait',
        };
      }
    }
  }

  @autobind
  public getMediaStream() {
    this.reset();
    return new Promise((resolve, reject) => {
      TRTC.isSupported().then(checkResult => {
        if (!checkResult.result) {
          // SDK 不支持当前浏览器，引导用户使用最新版的 Chrome 浏览器。
          message.error('当前浏览器不支持，请使用最新版的 Chrome 浏览器。');
          return;
        }
        const {
          isBrowserSupported,
          isWebRTCSupported,
          isMediaDevicesSupported,
          isH264EncodeSupported,
          isScreenShareSupported,
        } = checkResult.detail;
        // 不同的业务场景对检测的粒度要求不一样，有点场景只需推流、有的场景只需拉流
        // 判断浏览器是否支持采集摄像头、麦克风推流。
        const isPublishAudioStreamSupported =
          isBrowserSupported && isWebRTCSupported && isMediaDevicesSupported;
        const isPublishVideoStreamSupported =
          isBrowserSupported &&
          isWebRTCSupported &&
          isMediaDevicesSupported &&
          isH264EncodeSupported;
        if (!isPublishAudioStreamSupported || !isPublishVideoStreamSupported) {
          message.error('当前浏览器不支持，请使用最新版的 Chrome 浏览器。');
          resolve(null);
          return;
        }
        // 判断浏览器是否支持屏幕分享
        if (!isScreenShareSupported) {
          message.error(
            '当前浏览器不支持屏幕分享，请使用最新版的 Chrome 浏览器。'
          );
          resolve(null);
          return;
        }
        (async () => {
          const { DeviceState, trtc } = this;
          if (!trtc) {
            resolve(null);
            return;
          }
          const res = await TRTC.getPermissions({
            request: true, // 如果为 true，调用该接口可能会短暂打开摄像头来获取摄像头权限，以保证正常获取摄像头列表，随后 SDK 会自动释放采集。
            types: ['camera', 'microphone'], // 请求获取的设备类型。
          });
          if (res.camera === 'granted' && res.microphone === 'granted') {
            trtc.startLocalVideo({ publish: false }).catch(e => {
              this.DeviceState.camera.status = 'error';
              this.DeviceState.camera.txt = e.reason || '检测异常';
              this.DeviceState.micro.status = 'error';
              this.DeviceState.micro.txt = '设备检测异常';
              resolve(null);
            });
            // 首次打开麦克风
            trtc.startLocalAudio({ publish: false }).catch(e => {
              this.DeviceState.camera.status = 'error';
              this.DeviceState.camera.txt = '设备检测异常';
              this.DeviceState.micro.status = 'error';
              this.DeviceState.micro.txt = e.reason || '检测异常';
              resolve(null);
            });
            // const trackAudio = TRTC.getAudioTrack();
            trtc.on(TRTC.EVENT.TRACK, event => {
              const track = event.track;
              const kind = event.track.kind;
              const streamType = event.streamType;
              if (kind == 'audio') {
                track.onended = event => {
                  this.error = event;
                  this.dispose();
                };
              }
              if (
                kind == 'video' &&
                streamType === TRTC.TYPE.STREAM_TYPE_MAIN
              ) {
                track.onended = event => {
                  this.error = event;
                  this.dispose();
                };
                this.stream = new MediaStream([track]);
                resolve(this.stream);
              }
            });
            trtc.on(
              TRTC.EVENT.DEVICE_CHANGED,
              (event: {
                type: TRTCDeviceType;
                action: TRTCDeviceAction;
                device: MediaDeviceInfo;
              }) => {
                if (event?.action === 'remove') {
                  if (event.type === 'camera') {
                    this.DeviceState.camera.status = 'error';
                    this.DeviceState.camera.txt = '设备被移除';
                  }
                  if (event.type === 'microphone') {
                    this.DeviceState.micro.status = 'error';
                    this.DeviceState.micro.txt = '设备被移除';
                  }
                  logger.info('设备移除 🚀', event);
                  this.msInactiveHandler();
                }
              }
            );
          } else {
            if (res.camera === 'denied') {
              DeviceState.camera.txt = '请授权摄像头';
              DeviceState.camera.status = 'error';
            }
            if (res.microphone === 'denied') {
              DeviceState.micro.txt = '请授权麦克风';
              DeviceState.micro.status = 'error';
            }
            if (res.camera === 'prompt') {
              DeviceState.camera.txt = '请授权摄像头';
              DeviceState.camera.status = 'error';
            }
            if (res.microphone === 'prompt') {
              DeviceState.micro.txt = '请授权麦克风';
              DeviceState.micro.status = 'error';
            }
            resolve(null);
          }
        })();
      });
    });
  }

  @autobind
  public msInactiveHandler() {
    this.deviceActiveStatus = 'inactive';
    window.hetaoTrack('element_show', {
      elementName: '赛考赛前检测状态',
      statusText: 'inactive',
      live_status: 'inactive',
      userId: this.userService?.user?.userId || 0,
      uniqueId: this.userExamId,
    });
  }

  @autobind
  public reset() {
    this.deviceActiveStatus = '';
    this.stream = undefined;
    this.error = undefined;
  }

  @autobind
  public dispose() {
    logger.warn('warn media service dispose => 1', new Date().toLocaleString());
    if (this.stream) {
      logger.warn(
        'warn media service dispose => 2',
        new Date().toLocaleString()
      );
      try {
        logger.warn(
          'warn media service dispose => 3',
          new Date().toLocaleString()
        );
        this.stream.getTracks().forEach(track => track.stop());
        logger.warn(
          'warn media service dispose => 4',
          new Date().toLocaleString()
        );
      } catch (e) {
        logger.warn(
          'warn media service dispose => 5',
          new Date().toLocaleString()
        );
        // add sentry mark
        // console.log('setTag', 'dispose mediaService');
        logger.debug('dispose中停止音视频异常 => ', e);
      }
    }
    if (this.trtc) {
      (async function (trtc) {
        await trtc.stopLocalAudio();
        await trtc.stopLocalVideo();
        await trtc.stopScreenShare();
        trtc.destroy();
      })(this.trtc);
      this.trtc = undefined;
    }
    this.stream = undefined;
    this.deviceActiveStatus = '';
  }

  @autobind
  public parseErrorMsg(err: Error) {
    if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICEDISMISSED ||
      err.name === DeviceErrorDescription.ERRORMESSAGE_DEVICEDISMISSED
    ) {
      return {
        message: '权限未被允许或被驳回',
        otherMsg: '关闭了权限弹窗',
      };
    } else if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTFOUND ||
      err.name === DeviceErrorDescription.ERRORNAME_DEVICENOTFOUND
    ) {
      return {
        message: '未找到相关设备',
        otherMsg: '',
      };
    } else if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTALLOWED ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MOBILEDEVICE_NOTALLOWED ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MACSAFARI_DEVICENOTALLOWED
    ) {
      return {
        message: '不允许使用相关设备',
        otherMsg: '权限允许弹窗被拒绝，或被拒绝过',
      };
    } else if (
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MACCHROME_DEVICENOTREADABLE ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_VIDEODEVICENOTREADABLE ||
      err.name === DeviceErrorDescription.ERRORNAME_DEVICENOTREADABLE
    ) {
      return {
        message: '没有使用相关设备权限',
        otherMsg:
          '设备硬件错误，或浏览器被系统禁止权限，如Mac-安全性与隐私-隐私-麦克风',
      };
    } else if (
      err.name === DeviceErrorDescription.ERRORNAME_DEVICEOVERCONSTRAINED
    ) {
      return {
        message: '无法满足当前MediaStreamTrack的所需功能集',
        otherMsg: '',
      };
    }
    return null;
  }

  @autobind
  public getDeviceList(): Promise<Array<MediaDeviceInfo>> {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .enumerateDevices()
        .then(deviceList => {
          const arr: Array<MediaDeviceInfo> = [];
          deviceList.forEach((device: MediaDeviceInfo) => {
            arr.push(device);
          });
          resolve(arr);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  @autobind
  public getChromeVersion() {
    const userAgent = navigator.userAgent;
    const chromeVersionMatch = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
    if (chromeVersionMatch) {
      return {
        status: 200,
        version: `Chrome内核版本：${chromeVersionMatch[1]}`,
      };
    } else {
      return {
        status: 0,
        version: '非Chrom内核浏览器',
      };
    }
  }

  @autobind
  public async checkBrowser() {
    const { DeviceState } = this;
    await delayFn(1);
    const result = this.getChromeVersion();
    DeviceState.browser.status = result.status === 200 ? 'finish' : 'error';
    DeviceState.browser.txt = result.version;
  }
  public async checkVideo() {
    const { DeviceState } = this;
    DeviceState.camera.status = 'process';
    await delayFn(1);
    return new Promise((resovle, reject) => {
      TRTC.getCameraList()
        .then((list: any) => {
          if (list.length && list[0].deviceId) {
            DeviceState.camera.status = 'finish';
            DeviceState.camera.deviceList = list;
            DeviceState.camera.txt = list[0].label;
            this.canCheckTotal();
            resovle(true);
          } else {
            DeviceState.camera.txt = '~未找到可用设备~';
            DeviceState.camera.status = 'error';
            resovle(false);
          }
        })
        .catch((e: IError) => {
          DeviceState.camera.txt = e.reason || '~未找到设备~';
          DeviceState.camera.status = 'error';
          reject(e);
        });
    });
  }

  @autobind
  public async checkAudio() {
    const { DeviceState } = this;
    DeviceState.micro.status = 'process';
    await delayFn(1);
    return new Promise((resovle, reject) => {
      TRTC.getMicrophoneList()
        .then((list: any) => {
          if (list.length && list[0].deviceId) {
            DeviceState.micro.deviceList = list;
            DeviceState.micro.status = 'finish';
            DeviceState.micro.txt = list[0].label;
            this.canCheckTotal();
            resovle(true);
          } else {
            DeviceState.micro.txt = '~未找到可用设备~';
            DeviceState.micro.status = 'error';
            resovle(false);
          }
        })
        .catch((e: IError) => {
          DeviceState.micro.txt = e.reason || '~未找到设备~';
          DeviceState.micro.status = 'error';
          reject(e);
        });
    });
  }

  @autobind
  public async checkScreen(checkTotalFlag = true) {
    const { DeviceState } = this;
    DeviceState.screen.status = 'process';
    this.trtc?.stopScreenShare();
    await delayFn(1);
    return new Promise((resolve, reject) => {
      this.trtc
        ?.startScreenShare({ publish: false })
        .then(() => {
          DeviceState.screen.status = 'finish';
          DeviceState.screen.deviceList = [];
          DeviceState.screen.txt = '分享成功';
          if (checkTotalFlag) {
            this.canCheckTotal();
          }
          resolve(true);
        })
        .catch(rtcError => {
          if (rtcError.code == TRTC.ERROR_CODE.DEVICE_ERROR) {
            // 引导用户检查设备
            // 以下为可选代码
            switch (rtcError.extraCode) {
              case 5301:
                // 找不到摄像头或者麦克风，引导用户检查麦克风和摄像头是否正常。
                break;
              case 5302:
                if (rtcError.handler) {
                  // 提示用户系统关闭了浏览器的摄像头、麦克风、屏幕分享采集权限，即将跳转至系统权限设置 APP，请打开相关权限后，重启浏览器重试。
                  message.error(
                    '提示用户系统关闭了浏览器屏幕分享采集权限，请打开相关权限后，重启浏览器重试。'
                  );
                } else {
                  // 引导用户允许摄像头、麦克风、屏幕分享采集权限
                  message.error('请允许屏幕分享采集权限');
                  DeviceState.screen.txt = '请授权屏幕分享权限';
                  DeviceState.screen.status = 'error';
                }
                break;
              // ...
            }
          }
          if (checkTotalFlag) {
            reject(rtcError);
          } else {
            resolve(null);
          }
        });
    });
  }

  @autobind
  public judgeSuccess() {
    const { DeviceState } = this;
    return (
      DeviceState.camera.status === 'finish' &&
      DeviceState.micro.status === 'finish' &&
      DeviceState.screen.status === 'finish'
    );
  }
  @autobind
  public async canCheckTotal() {
    const { DeviceState } = this;
    if (this.judgeSuccess() && !this.stream) {
      try {
        await this.getMediaStream();
        DeviceState.camera.status = 'finish';
        DeviceState.micro.status = 'finish';
        DeviceState.showVideo = true;
        // // 更新检测记录
        // await this.updateCheckRecord();
      } catch (e) {
        if (e instanceof Error) {
          const errResult = this.parseErrorMsg(e);
          if (errResult) {
            DeviceState.camera.txt = errResult.message;
            DeviceState.camera.status = 'error';
            DeviceState.micro.txt = errResult.message;
            DeviceState.micro.status = 'error';
          }
        }
      }
    }
  }

  @autobind
  // 其他需要检测的明细
  public getCheckBrowserResult() {
    const result = checkBrowser();
    this.checkBrowserResult = result;
    return result;
  }

  /**
   * 正常环境检测结束的后续处理方法
   * 对应的是检测超时处理方法
   *
   * @param {*} result
   * @return {*}
   */
  @autobind
  public normalFinishCheck() {
    if (!this.checkId) return; // 如果checkId不存在，则后续不处理了
    this.updateCheckRecord();
    this.dispose();
  }

  /**
   * 开始环境检测，从服务器端获取检测ID
   *
   * @return {*}
   * @memberof EnvCheckService
   */
  @autobind
  public getStartCheckId() {
    return this.daoService.addCheckRecord(this.userExamId).then(res => {
      this.checkId = res;
    });
  }

  /**
   * 检测完成，需要保存检测结果
   *
   * @return {*}
   */
  @autobind
  public async updateCheckRecord(isSkipFlag = false) {
    const { DeviceState } = this;
    const MicroStatusOk = DeviceState.micro.status === 'finish';
    const CameraStatusOk = DeviceState.camera.status === 'finish';
    const DeviceCheckStatus = MicroStatusOk && CameraStatusOk ? 1 : 0;
    let result: any = {};
    // 是否跳过检测
    if (isSkipFlag) {
      result = {
        id: this.checkId,
        result: CheckStatusEnum.SKIP,
        checkItems: {
          userAgent: navigator.userAgent,
          checkVideoAndAudioState: 0,
          checkDeviceData: {
            videoName: '',
            audioName: '',
          },
          ...(this.checkBrowserResult || {}),
        },
        userExamId: this.userExamId,
      };
    } else {
      result = {
        id: this.checkId,
        result: DeviceCheckStatus,
        checkItems: {
          userAgent: navigator.userAgent,
          checkVideoAndAudioState: MicroStatusOk && CameraStatusOk ? 1 : 0, // 1代表检测成功，0代表失败
          checkDeviceData: {
            videoName: DeviceState.camera.txt || '',
            audioName: DeviceState.micro.txt || '',
          },
          ...(this.checkBrowserResult || {}),
        },
        userExamId: this.userExamId,
      };
    }
    const res = await this.daoService.updateCheckRecord(result);
    this.InitCheckResult.device = result.result;
    const deviceStep = this.checkStep[0];
    if (isSkipFlag || !DeviceCheckStatus) {
      deviceStep.status = 'error';
      deviceStep.resultStatus = 'error';
      deviceStep.recordError = true;
    } else {
      deviceStep.status = 'finish';
      deviceStep.resultStatus = 'wait';
      deviceStep.recordError = false;
    }
    return res;
  }

  /**
   * 获取检测结果
   */
  @autobind
  public async getCombinationResult() {
    this.pageInitLoading = true;
    try {
      const res: any = await this.daoService.getCombinationResult({
        userExamId: this.userExamId,
        contestInfoId: this.contestInfoId,
      });
      this.faceCheckStandardUrl = res?.faceCheckStandardUrl;
      this.checkId = res?.checkRecordInfo?.id ?? 0;
      this.photoDataUrl =
        res?.faceRecordInfo?.result === 2
          ? ''
          : res?.faceRecordInfo?.signatureUrl ?? '';
      // 判断是否添加了身份验证
      const hasFaceCheck = res?.faceCheckConfigStatus === 1;
      this.combinationResult = {
        ...res,
        needCheckFace: hasFaceCheck,
      };
      this.InitCheckResult = {
        device: res?.checkRecordInfo?.result ?? CheckStatusEnum.NO_CHECK,
        face: res?.faceRecordInfo?.result ?? CheckStatusEnum.NO_CHECK,
        mobile: res?.mobileRecordInfo?.result
          ? CheckStatusEnum.PASS
          : CheckStatusEnum.NO_CHECK,
      };
      // 不存在身份校验 就删除第二部
      if (!hasFaceCheck) {
        this.checkStep.splice(2, 1);
      }
      // 判断是否检测过了设备 浏览器
      if (res?.checkRecordInfo?.result === CheckStatusEnum.PASS) {
        this.currentStepIndex = 1;
        this.goStep(1);
      }
      if (res?.mobileRecordInfo?.result) {
        this.currentStepIndex = 2;
        this.goStep(2);
      }
      const lastIndex = this.checkStep.length - 1;
      if (
        hasFaceCheck &&
        res?.faceRecordInfo?.result === CheckStatusEnum.PASS
      ) {
        this.currentStepIndex = lastIndex;
        this.goStep(lastIndex);
      }
      // 跳过了检测
      if (res?.checkRecordInfo?.result === CheckStatusEnum.SKIP) {
        if (this.route.meta.platform) {
          this.goStep(0);
        } else {
          this.goStep(lastIndex);
          this.checkStep.forEach((el: StepItemtype) => {
            if (el.stepType < lastIndex) {
              el.status = 'error';
              el.resultStatus = 'error';
              el.recordError = true;
            } else {
              el.resultStatus = 'wait';
            }
          });
        }
      }
      if (
        hasFaceCheck &&
        res?.faceRecordInfo?.result === CheckStatusEnum.SKIP &&
        res?.checkRecordInfo?.result === CheckStatusEnum.PASS
      ) {
        this.goStep(1);
      }
      if (this.currentStepIndex === 0) {
        this.NeedAutoCheckDevice = true;
      } else {
        this.NeedAutoCheckDevice = false;
      }
      this.pageInitLoading = false;
    } catch (e: any) {
      this.pageInitLoading = false;
      if (e?.errCode === 10000) {
        this.router.push({
          name: this.route.meta.entryUrlName || 'UserItemList',
        });
      }
    }
  }

  /**
   * 开始检测设备
   * @returns
   */
  @autobind
  public checkStartDevice() {
    return new Promise((resolve, reject) => {
      const { DeviceState } = this;
      DeviceState.browser.status = 'process';
      DeviceState.micro.status = 'process';
      DeviceState.camera.status = 'process';
      DeviceState.screen.status = 'process';
      const asyncCheckStart = async () => {
        try {
          await Promise.allSettled([
            this.checkBrowser(),
            this.getMediaStream(), // catch 异常
            this.getCheckBrowserResult(), // 一定成功
            this.checkScreen(false),
            delayFn(1),
          ]);
          const list = await this.getDeviceList();
          DeviceState.micro.deviceList = [];
          DeviceState.camera.deviceList = [];
          list.forEach((el: MediaDeviceInfo) => {
            if (el.kind === 'audioinput') {
              DeviceState.micro.deviceList.push(el);
            }
            if (el.kind === 'videoinput') {
              DeviceState.camera.deviceList.push(el);
            }
          });
          if (this.stream) {
            if (DeviceState.micro.status !== 'error') {
              DeviceState.micro.status = 'finish';
              DeviceState.micro.txt = DeviceState.micro.deviceList[0]?.label;
            }
            if (DeviceState.camera.status !== 'error') {
              DeviceState.camera.status = 'finish';
              DeviceState.camera.txt = DeviceState.camera.deviceList[0]?.label;
            }
          } else {
            DeviceState.micro.status = 'error';
            DeviceState.micro.txt ||= '未知异常';
            DeviceState.camera.status = 'error';
            DeviceState.camera.txt ||= '未知异常';
          }
          DeviceState.showVideo = true;
          // 状态置为已点击检测
          DeviceState.hasClickChecked = true;
          resolve(true);
        } catch (e: any) {
          // 状态置为已点击检测
          DeviceState.hasClickChecked = true;
          reject(e);
        }
      };
      asyncCheckStart();
    });
  }

  @autobind
  public uploadFaceUrl(blobData: Blob) {
    const fileName = this.cosService.getBlobName(
      'face-identity',
      `${this.userService?.user?.userId}_pic.png`
    );
    return this.cosService.uploadBlob({
      blob: blobData,
      fileName,
      cosType: 'face',
    });
  }

  /**
   * 更新身份验证结果
   * @param url
   * @param result
   * @returns
   */
  @autobind
  public async updateFaceCheckResult(url: string, result = 1) {
    const res = await this.daoService.updateFaceCheckResult({
      imgUrl: url,
      result,
      userExamId: this.userExamId,
      userId: this.userService?.user?.userId,
    });
    this.InitCheckResult.face = result;
    const faceStep = this.checkStep[1];
    if (result === 0) {
      faceStep.status = 'error';
      faceStep.resultStatus = 'error';
      faceStep.recordError = true;
    } else {
      faceStep.status = 'finish';
      faceStep.resultStatus = 'wait';
      faceStep.recordError = false;
    }
    return res;
  }

  @autobind
  public async updateMobileCheckResult() {
    const res = await this.daoService.updateMobileCheckResult({
      cause: '正常点击',
      result: true,
      userExamId: this.userExamId,
      userId: Number(this.userService?.user?.userId),
    });
    this.InitCheckResult.mobile = CheckStatusEnum.PASS;
    const mobileStep = this.checkStep[2];
    mobileStep.status = 'finish';
    mobileStep.resultStatus = 'wait';
    mobileStep.recordError = false;
    return res;
  }

  @autobind
  public getExamDuration() {
    this.examDetailGeted = false;
    this.daoService
      .getExamSummary({
        userExamId: this.userExamId,
      })
      .then((res: any) => {
        this.examDetail = res;
        this.startExamTimestamp = res.startTimestamp;
        this.serverRemainTime = res.currentTimestamp;
        this.isCanEntrance = this.startExamTimestamp <= this.serverRemainTime;
        this.localGetRemainTime = Date.now();
        if (this.isCanEntrance) {
          this.uninstallCountDown();
        } else {
          this.countDownTimeData = this.formatCountDownTime(
            this.serverRemainTime,
            this.startExamTimestamp
          );
          this.setCountdownTimer();
        }
      })
      .catch((e: any) => {
        this.isCanEntrance = false;
        this.uninstallCountDown();
        if ([5010, 5014].includes(e?.errCode)) {
          const otherLoginUrl = getOtherLoginUrl() || '';
          if (otherLoginUrl) {
            setTimeout(() => {
              window.location.replace(otherLoginUrl);
            }, 2000);
          } else {
            this.router.push({
              name: 'UserItemList',
            });
          }
        }
      })
      .finally(() => {
        this.examDetailGeted = true;
      });
  }

  @autobind
  public countDownFn() {
    this.localTime = Date.now();
    this.localTimeGap = this.localTime - this.localGetRemainTime;
    const fakeServerTime = this.localTimeGap + this.serverRemainTime;
    if (fakeServerTime < this.startExamTimestamp) {
      this.countDownTimeData = this.formatCountDownTime(
        fakeServerTime,
        this.startExamTimestamp
      );
      this.setCountdownTimer();
    } else {
      this.isCanEntrance = true;
      this.uninstallCountDown();
    }
  }

  @autobind
  public formatCountDownTime(startTime: number, endTime: number) {
    if (startTime > endTime) {
      return {
        h: '00',
        min: '00',
        sec: '00',
      };
    }
    const timeGap = endTime - startTime;
    const hours = Math.floor(timeGap / (1000 * 60 * 60));
    const minutes = Math.floor((timeGap % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeGap % (1000 * 60)) / 1000);
    const padZero = (num: number) => num.toString().padStart(2, '0');

    return {
      h: padZero(hours),
      min: padZero(minutes),
      sec: padZero(seconds),
    };
  }

  /**
   * 设置倒计时的定时器
   *
   * @memberof CountdownService
   */
  @autobind
  public setCountdownTimer() {
    window.clearTimeout(this.countdownTimer);
    this.countdownTimer = window.setTimeout(this.countDownFn, 1000);
  }

  @autobind
  public uninstallCountDown() {
    window.clearTimeout(this.countdownTimer);
  }

  @autobind
  public uninstall() {
    this.dispose();
    this.uninstallCountDown();
  }

  @autobind
  public handleIgnoreCheckStep() {
    this.getCheckBrowserResult();
    const SkipFlag = true;
    const PromiseArr: any[] = [this.updateCheckRecord(SkipFlag)];
    const lastStepIndex = this.checkStep.length;
    if (this.combinationResult?.faceCheckConfigStatus === 1) {
      PromiseArr.push(this.updateFaceCheckResult('', CheckStatusEnum.SKIP));
    }
    return Promise.all([...PromiseArr]).then(() => {
      this.goStep(lastStepIndex - 1);
      this.NoDeviceVisible = false;
      this.checkStep.forEach((el: StepItemtype) => {
        if (el.stepType < 3) {
          el.status = 'error';
          el.resultStatus = 'error';
          el.recordError = true;
        }
      });
    });
  }
}
